import * as React from 'react';
import { PageSection } from '../../../atoms/layout/PageSection';
import { LoaderRow } from '../../../atoms/layout/LoaderRow';
import { EventListPane } from '../EventListPane';
import { GlobalStatesV3 } from '../../../../../commonv3/states/GlobalStatesV3';
import { V3Routes } from '../../../../routes';
import { observer } from 'mobx-react';

export const EventArchivesSection = observer(({ eventList }) => {
    if (eventList.eventArchives.loading) {
        return <LoaderRow />;
    }
    if (!eventList.hasArchives) {
        return null;
    }
    return (
        <PageSection title="EVENT ARCHIVES" subTitle="過去のイベント" background="white">
            <EventListPane
                events={eventList.eventArchives.getOrElse([])}
                onItemClick={(ev) => GlobalStatesV3.routing.push(V3Routes.event(ev.id))}
            />
        </PageSection>
    );
});
